import { create } from 'zustand';

interface SpotlightState {
  /** The ID of the element currently being spotlighted */
  activeSpotlight: string | null;
  /** Whether to show a backdrop overlay */
  showOverlay: boolean;
  /** Set the active spotlight element */
  setSpotlight: (id: string | null, withOverlay?: boolean) => void;
  /** Clear the spotlight */
  clearSpotlight: () => void;
}

export const useSpotlight = create<SpotlightState>((set) => ({
  activeSpotlight: null,
  showOverlay: false,
  setSpotlight: (id, withOverlay = false) =>
    set({ activeSpotlight: id, showOverlay: withOverlay }),
  clearSpotlight: () => set({ activeSpotlight: null, showOverlay: false }),
}));
